import React from "react";

const Loading = () => {
  return <div className="loading"/>
}

export default Loading;